import React from 'react';
import {
  objectArraySort,
  Flex,
  Avatar,
  PermissionGuard,
} from '@mss/mss-component-library';
import dateFormat from 'dateformat';
import { TFunction } from 'i18next';
import RevokeSessionRowButton from '../../../components/RevokeSessionRowButton';
import SessionRecordingRowButton from '../../../components/SessionRecordingRowButton';
import SessionStatus from '../../../../common/SessionStatus';

const columns = (t: TFunction, fetchSession: () => void) => [
  {
    title: '',
    dataIndex: '',
    key: '',
    width: 30,
    render: (record: any) => (
      <Flex h="center" v="center">
        <Avatar
          firstName={record.user?.first_name || ''}
          lastName={record.user?.last_name || ''}
        />
      </Flex>
    ),
  },
  {
    title: t('User'),
    dataIndex: ['user_object', 'name'],
    key: 'user_name',
    sorter: (a: any, b: any) => objectArraySort(a, b, 'user_name'),
  },
  {
    title: t('Target asset'),
    dataIndex: ['asset_object', 'name'],
    key: 'asset_name',
    width: 165,
    sorter: (a: any, b: any) => objectArraySort(a, b, 'asset_name'),
  },
  {
    title: t('Protocol'),
    dataIndex: 'protocol',
    key: 'protocol',
    width: 100,
    sorter: (a: any, b: any) => objectArraySort(a, b, 'protocol'),
    render: (protocol: string) => <>{protocol.toUpperCase()}</>,
  },
  {
    title: t('Status'),
    dataIndex: 'status',
    key: 'status',
    width: 165,
    sorter: (a: any, b: any) => objectArraySort(a, b, 'status'),
    render: (status: string) => <SessionStatus status={status} />,
  },
  {
    title: t('Started at'),
    dataIndex: 'created_at',
    key: 'created_at',
    width: 150,
    sorter: (a: any, b: any) => objectArraySort(a, b, 'created_at'),
    render: (record: any) =>
      record && dateFormat(record || '', 'mmmm dS, yyyy @ h:MM:ss TT'),
  },
  {
    title: t('Last activity'),
    dataIndex: 'last_activity',
    key: 'last_activity',
    width: 150,
    sorter: (a: any, b: any) => objectArraySort(a, b, 'last_activity'),
    render: (record: any) =>
      record && dateFormat(record || '', 'mmmm dS, yyyy @ h:MM:ss TT'),
  },
  {
    title: '',
    key: 'actions',
    width: 40,
    render: (record: any) => (
      <Flex onClick={e => e.stopPropagation()}>
        <PermissionGuard codename={'admin_update_remotesession'}>
          {record.status === 'active' && (
            <RevokeSessionRowButton
              session={record}
              fetchSession={fetchSession}
            />
          )}
        </PermissionGuard>
        <SessionRecordingRowButton session={record} />
      </Flex>
    ),
  },
];

export default columns;
